import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var ConstructionSvg = function ConstructionSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m8.41 2.249 11.704 4.598v4.274h-1.415V8.042h-6.603v9.574h-1.414V8.042H9.267v9.074H7.852V8.042H2zm7.247 4.373h-6.39V4.11zm-9.97 0 2.165-1.957v1.957z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.454 13.962h1.415v3.078h.943v-3.078h1.415v3.078h.943v-3.078h1.415v3.078H22v5.209H2V17.04h12.454zm-11.04 6.866v-2.367h17.171v2.367z",
    clipRule: "evenodd"
  }));
};
export var Construction = function Construction(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: ConstructionSvg
  }));
};